<div>
  <div class="banner" *ngIf="showBannerTop">
    <p class="top-text">{{ bannerText1 }}</p>
    <p class="middle-heading">{{ bannerText2 }}</p>
    <p class="bottom-desc">
      {{ bannerText3 }}
    </p>
  </div>
  <div class="quick-tracking-widget">
    <div class="separator"></div>
    <p class="heading">{{ 'landing.quicktracking' | cxTranslate }}</p>
    <p class="description mb-4">{{ 'landing.instantlysee' | cxTranslate }}</p>
    <br />
    <div>
      <form [formGroup]="orderCheckoutForm">
        <div class="container">
          <div class="row">
            <div class="vs-text-field col-lg-3 space-right-cn">
              <label class="search-field-label"
                ><span class="star"></span
                >{{ 'landing.customerno' | cxTranslate }}
              </label>
              <input
                type="text"
                class="txt-field-length"
                formControlName="customerNumber"
                (keypress)="numberOnly($event)"
                [ngClass]="firstMandateFieldError ? 'error-select' : ''"
                maxlength="10"
              />
            </div>
            <div class="vs-text-field col-lg-3 space-right-pon">
              <label class="search-field-label"
                ><span class="star"></span
                >{{ 'landing.purchaseno' | cxTranslate }}
              </label>
              <input
                type="text"
                class="txt-field-length"
                formControlName="purchaseOrderNo"
                [ngClass]="secondMandateFieldError ? 'error-select' : ''"
                maxlength="35"
              />
            </div>
            <div class="or-divide space-right-or">
              {{ 'landing.or' | cxTranslate }}
            </div>
            <div class="vs-text-field col-lg-3 space-right-qr">
              <label class="search-field-label"
                ><span class="star"></span>
                {{ 'landing.orderrefno' | cxTranslate }}
              </label>
              <input
                type="text"
                class="txt-field-length"
                (keypress)="numberOnly($event)"
                formControlName="referenceNumber"
                [ngClass]="secondMandateFieldError ? 'error-select' : ''"
                maxlength="10"
              />
            </div>

            <div class="submit-btn">
              <button class="vs-primary-btn" (click)="submitTrackStatus()">
                <em class="material-icons">search</em>
                {{ 'landing.trackStatus' | cxTranslate }}
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <label class="error" *ngIf="firstMandateFieldError"
                >{{ 'landing.quickcustomer' | cxTranslate }}
              </label>
            </div>
            <div class="col-6">
              <label class="error-custom" *ngIf="secondMandateFieldError"
                >{{ 'landing.quickpurchase' | cxTranslate }}
              </label>
              <label
                class="error-custom"
                *ngIf="form['purchaseOrderNo'].errors?.['pattern']"
                >{{ 'landing.quicktrackpo' | cxTranslate }}
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
